import { useState } from 'react'
import {ArrowRight, Check} from 'lucide-react'

function QuickContactForm() {
  const [submitted, setSubmitted] = useState(false)
  const [form, setForm] = useState({ name: '', email: '', company: '', message: '' })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setSubmitted(true)
    setTimeout(() => {
      setSubmitted(false)
      setForm({ name: '', email: '', company: '', message: '' })
    }, 3500)
  }

  if (submitted) {
    return (
      <div className="bg-white border border-soft rounded-2xl p-10 text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-orange-accent/10 flex items-center justify-center mb-5">
          <Check className="w-6 h-6 text-orange-accent" />
        </div>
        <h3 className="font-display text-2xl text-navy font-bold mb-2">Message received.</h3>
        <p className="text-muted">A Delta specialist will reach out within one business hour.</p>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="bg-white border border-soft rounded-2xl p-7 md:p-9 shadow-sm">
      <div className="mb-6">
        <h3 className="font-display text-2xl text-navy font-bold">Talk to a specialist</h3>
        <p className="text-muted text-sm mt-1">We'll respond within one business hour.</p>
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <input
            required name="name" value={form.name} onChange={handleChange}
            placeholder="Full name"
            className="w-full px-4 py-3 border border-soft rounded-lg text-sm focus:outline-none focus:border-orange-accent transition"
          />
          <input
            required name="company" value={form.company} onChange={handleChange}
            placeholder="Company"
            className="w-full px-4 py-3 border border-soft rounded-lg text-sm focus:outline-none focus:border-orange-accent transition"
          />
        </div>
        <input
          required type="email" name="email" value={form.email} onChange={handleChange}
          placeholder="Work email"
          className="w-full px-4 py-3 border border-soft rounded-lg text-sm focus:outline-none focus:border-orange-accent transition"
        />
        <textarea
          required name="message" value={form.message} onChange={handleChange}
          rows={4} placeholder="Tell us about your property and needs"
          className="w-full px-4 py-3 border border-soft rounded-lg text-sm focus:outline-none focus:border-orange-accent transition resize-none"
        />
        <button
          type="submit"
          className="w-full bg-orange-accent hover:bg-orange-dark text-white py-3.5 rounded-lg font-semibold text-sm tracking-wide transition-all flex items-center justify-center gap-2 group"
        >
          Send Message
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </button>
      </div>
    </form>
  )
}

export default QuickContactForm
